import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import './index/hotelCssImport';
import './index/reviews/reviews.scss';
import './reviews-page/reviews-page.scss';
import OurReviewsList from '@fr/pages/desktop/travelata/default-application/hotel/index/reviews/ourReviews/OurReviewsList';

class ReviewsDesktop extends Backbone.Epoxy.View {
  initialize() {
    this.ourReviewsList = new OurReviewsList({
      el: '#reviews-page',
    });
    this.ourReviewsList.load();
  }
}

$(() => {
  new ReviewsDesktop({
    el: '#reviews-page',
  });
});
